import '../../styles/speaker.css';
import logo from '../../assets/images/Q3logotext.png';
import adrian from '../../assets/images/speakers/adrian.jpg'; // note capital A

function Adrian() {
  return (
    <>
      <div className="header">
        <div className="header-content">
          <div className="left">
            <div className="header-box">
              <h1 className="title">
                Q<sup>3</sup> Initiative: QEthics @ USC
              </h1>
            </div>
            <p>September 12, 2025 - September 13, 2025</p>
            <p>University of Southern California</p>
            <p>TBD</p>
          </div>
          <div className="right">
            <img src={logo} className="logo" alt="Q^3 Logo" />
          </div>
        </div>
      </div>

      <div className="speaker-box">
        <div className="speaker-photo">
          <img src={adrian} alt="Adrian Esteban Acosta" className="speakerspic" />
        </div>
        <div className="speaker-content">
          <h1>Adrian Esteban Acosta</h1>
          <h2>Quantum Researcher &amp; QSL Fellow</h2>
        </div>
      </div>

      <div className="speaker-content">
        <p className="p">
          My name is Adrian Esteban Acosta, I come from Chicago and graduated from the University of
          Iowa with a B.S. in both physics and economics. My primary work at Space Dynamics
          Laboratory (SDL) consists of ionospheric modelling, auroral boundary study, as well as
          projects in the Quantum Sensing and Timing group (QST). My secondary work is with WISER as
          a Quantum Solutions Launchpad (QSL) fellow, where I study Majorana systems and find ways
          to benchmark them and evaluate their performance across quantum hardware, a project idea
          offered by the Naval Nuclear Laboratory (NNL). Future plans include continuing my WISER
          work and applying to return to graduate school to pursue my masters in physics.
        </p>
      </div>
    </>
  );
}

export default Adrian;
